module.exports = __webpack_public_path__ + "img/ghs.d0289dc0.png";